import { createContext, useContext, type ReactNode } from 'react'

/** Was „Testdaten entfernen“ trifft — lebende Zeilen mit Testdaten-Herkunft (#269). */
export interface TestDataCount {
  projects: number
  tasks: number
  goals: number
  habits: number
}

/** Was ein Lauf von „Testdaten anlegen“ angelegt hat; der Samen stellt ihn nach (`npm run testdata -- --seed`). */
export interface TestDataCreated {
  seed: number
  projects: number
  tasks: number
}

/**
 * **Testdaten anlegen und entfernen** (#269) — für Bausteine außerhalb des Features (Einstellungen,
 * Hauptfenster). Der Erzeuger liegt in `features/taskManagement`, das `components/` nicht importieren
 * darf; das Feature füllt deshalb diesen Kontext (`TestDataActionsProvider`), die App-Wurzeln setzen ihn.
 */
export interface TestDataActions {
  count(): Promise<TestDataCount>
  create(): Promise<TestDataCreated>
  remove(): Promise<TestDataCount>
}

const TestDataActionsContext = createContext<TestDataActions | null>(null)

export function TestDataActionsContextProvider({ actions, children }: { actions: TestDataActions; children: ReactNode }) {
  return <TestDataActionsContext.Provider value={actions}>{children}</TestDataActionsContext.Provider>
}

/** `null` ohne Provider (Stories, Tests ohne Attrappe) — wer es liest, zeigt sich dann nicht. */
export function useTestDataActions(): TestDataActions | null {
  return useContext(TestDataActionsContext)
}

/** Nichts mehr da, was „Entfernen“ träfe. */
export function isEmptyTestDataCount(count: TestDataCount): boolean {
  return count.projects + count.tasks + count.goals + count.habits === 0
}
